import { Sender } from 'xstate';
import { LogicContext } from '../types';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';

export const waitForHeader = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'WH_HEADER_TIMEOUT';
      }>
    ) => {
      let eventSent: boolean = false;
      const timeoutId = setTimeout(() => {
        console.log('Header initialized timeout');
        if (!eventSent) {
          callback({ type: 'WH_HEADER_TIMEOUT' });
        }
        eventSent = true;
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  );
